const Middle = () => {
  return (
    <div className="w-full py-8 sm:py-16 px-6 sm:px-14 border-b-4 border-gray-700">
      <div className="aspect-h-9 aspect-w-16">
        <iframe
          title="vimeo-player"
          src="https://player.vimeo.com/video/725320240?h=bb3643ae15"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  );
};

export default Middle;
